import Vue from 'vue'
import VueRouter from 'vue-router'

import videoPage from '../components/videoPage.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: videoPage },

  { path: '/item/:id/:eid', component: videoPage, props: { footer: false, header: false} },
  
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  }
})
 
export default router
